import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createApp } from 'vue';

import axiosWrapperConfig from '@/api/config';

import '@/assets/styles/index.css';

import App from './App.vue';
import { i18n } from './locales';
import router from './router';
import { getSentryOptions } from '@/service/observability/config';
import type { Environment } from '@/service/observability/config';
import { createGtm } from '@gtm-support/vue-gtm';
import axiosWrapper from '@mylight150/axios-wrapper';
import regenerativUi from '@regenerativ/regenerativ-ui-vue';
import '@regenerativ/regenerativ-ui-vue/dist/style.css';
import * as Sentry from '@sentry/vue';

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const dsnSentry = import.meta.env.VITE_SENTRY_DSN;
const env = import.meta.env.VITE_APP_ENV as Environment | undefined;
const networkDetailAllowUrls: Array<string> = [import.meta.env.VITE_SENTRY_NETWORK_ALLOW_URL_REGEX];

if (dsnSentry) {
  const sentryOptions = getSentryOptions({
    app,
    router,
    pinia,
    dsnSentry,
    env,
    networkDetailAllowUrls,
  });
  Sentry.init(sentryOptions);
}

app.use(pinia);
app.use(axiosWrapper, { axiosWrapperConfig });

app.use(router);

if (import.meta.env.VITE_GTM_ID) {
  app.use(createGtm({ id: import.meta.env.VITE_GTM_ID, vueRouter: router }));
}

app.use(i18n);

app.use(regenerativUi);

router.isReady().then(() => {
  app.mount('#app');
});
